import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import 'rsuite/dist/rsuite.min.css';
import { Provider } from 'react-redux';
import { persistor, store } from '@/Store';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from '@/Components/ErrorBoundry/wrapper';
import Loading from '@/Components/Common/Loading';

const AppComponent = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Suspense fallback={<Loading />}>
              <AppComponent />
            </Suspense>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
